import type { User } from "@supabase/supabase-js";

export interface ContactFormDefaults {
  name: string;
  email: string;
}

/** Prefill values for the contact form from an authenticated Supabase user. */
export function getContactFormDefaultsFromUser(user: User | null): ContactFormDefaults {
  if (!user) {
    return { name: "", email: "" };
  }

  const email = user.email?.trim() ?? "";
  const metadata = user.user_metadata ?? {};
  const fullName = typeof metadata.full_name === "string" ? metadata.full_name.trim() : "";
  const displayName = typeof metadata.display_name === "string" ? metadata.display_name.trim() : "";
  const legacyName = typeof metadata.name === "string" ? metadata.name.trim() : "";

  return {
    name: fullName || displayName || legacyName,
    email,
  };
}

/** Merge auth defaults into contact form state without overwriting user input. */
export function mergeContactFormDefaults(
  current: ContactFormDefaults,
  defaults: ContactFormDefaults
): ContactFormDefaults {
  return {
    name: current.name.trim() ? current.name : defaults.name,
    email: current.email.trim() ? current.email : defaults.email,
  };
}
